import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Common Pages
import Header from './components/Header';
import HeroSection from './components/Herosection';
import About from './components/About';
import Service from './components/Service';
import Footer from './components/Footer';
import Servicepg from './components/Servicepg';
import Servicehero from './components/Servicehero';
import ContactPage from './components/Contactpage';
import Contacthero from './components/Contacthero';
import Mission from './components/Mission';
import Methodology from './components/Methodology';
import Certificatepg from './components/Certificatepg';
import Appreciationpg from './components/Appreciationpg'; // ✅ Imported Appreciation Page

// Service Detail Pages
import Engineeringdesign from './components/Engineeringdesign';
import Testingcommissioning from './components/Testingcommissioning';
import Equipmentrental from './components/Equipmentrental';
import Skilledmanpower from './components/Skilledmanpower';
import Oilfiltration from './components/Oilfiltration';
import Maintenanceservices from './components/Maintenanceservices';

// Rental Pages
import Rental from './components/Rental';
import Selectrental from './components/Selectrental';
import RotatingCarousel from './components/RotatingCarousel';
import Business from './components/Business';
import Count from './components/Count';
import Aboutpr from './components/Aboutpr';
import Stepbystep from './components/Stepbystep';
import Cercarousel from './components/Cercarousel';
import Epc from './components/Epc';
import Elecinstallation from './components/Elecinstallation';
import Renewable from './components/Renewable';
import Scada from './components/Scada';
import Project from './components/Project';
import Client from './components/Client';
import Careers from './components/Careers';

// Projects
import OngoingProjects from './components/OngoingProjects';
import CompletedProjects from './components/CompletedProjects';
import VideoYearTimeline from './components/VideoYearTimeline';

// ✅ IMPORT 404 PAGE
import NotFound from './components/NotFound';
import Cablepg from './components/Cablepg'; // 1. Add import

// Home Page
function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      <About />
      <RotatingCarousel />
      <Business />
      <Count />
      <Footer />
    </>
  );
}

// About Page
function Abouts() {
  return (
    <>
      <Header />
      <Aboutpr />
      <Stepbystep />
      <Mission />
      <Footer />
    </>
  );
}

// Certificate Page
function Certificatepage() {
  return (
    <>
      <Header />
      <Certificatepg />
      <Cercarousel />
      <Footer />
    </>
  );
}

// ✅ Appreciation Page
function Appreciationpage() {
  return (
    <>
      <Header />
      <Appreciationpg />
      <Footer />
    </>
  );
}

// EPC Page
function Epcpage() {
  return (
    <>
      <Header />
      <Epc />
      <Footer />
    </>
  );
}

// Services Page
function ServicePage() {
  return (
    <>
      <Header />
      <Servicepg />
      <Servicehero />
      <Methodology />
      <Service />
      <Footer />
    </>
  );
}

// Contact Page
function ContactPg() {
  return (
    <>
      <Header />
      <ContactPage />
      <Contacthero />
      <Footer />
    </>
  );
}

// Ongoing Projects
function OngoingProjectPg() {
  return (
    <>
      <Header />
      <OngoingProjects />
      <Footer />
    </>
  );
}

// Completed Projects
function CompletedProjectPg() {
  return (
    <>
      <Header />
      <CompletedProjects />
      <Footer />
    </>
  );
}

// VTEX Page
function VtexPage() {
  return (
    <>
      <Header />
      <VideoYearTimeline />
      <Footer />
    </>
  );
}
function CablePage() { // 2. Add wrapper (if you want Header/Footer)
  return (
    <>
      <Header />
      <Cablepg />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>

        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Abouts />} />
        <Route path="/certificatepg" element={<Certificatepage />} />
        
        {/* ✅ FIXED ROUTE: Now matches http://localhost:3000/projects/appreciationpg */}
        <Route path="/projects/appreciationpg" element={<Appreciationpage />} /> 
        
        <Route path="/servicepg" element={<ServicePage />} />
        <Route path="/projectpg" element={<Project />} />
        <Route path="/projects/ongoing" element={<OngoingProjectPg />} />
        <Route path="/projects/completed" element={<CompletedProjectPg />} />
        <Route path="/clientpg" element={<Client />} />
        <Route path="/Careerspg" element={<Careers />} />
        <Route path="/contactpg" element={<ContactPg />} />

        {/* VTEX */}
        <Route path="/vtex" element={<VtexPage />} />

        {/* Services */}
        <Route path="/services/epcpage" element={<Epcpage />} />
         <Route path="/services/cablepg" element={<CablePage />} /> {/* 3. Add Route */}
        <Route path="/services/designpg" element={<Engineeringdesign />} />
        <Route path="/services/elecinstallatingpg" element={<Elecinstallation />} />
        <Route path="/services/testingcommissioningpg" element={<Testingcommissioning />} />
        <Route path="/services/Renewablepg" element={<Renewable />} />
        <Route path="/services/operationmaintenancepg" element={<Maintenanceservices />} />
        <Route path="/services/equipmentrentalpg" element={<Equipmentrental />} />
        <Route path="/services/oilfiltrationpg" element={<Oilfiltration />} />
        <Route path="/services/manpowerpg" element={<Skilledmanpower />} />
        <Route path="/services/scadapg" element={<Scada />} />

        {/* Rental */}
        <Route path="/rental" element={<Rental />} />
        <Route path="/select-rental/:model" element={<Selectrental />} />

        {/* ✅ 404 PAGE MUST BE LAST */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
}

export default App;